module.exports = __webpack_public_path__ + "static/media/logo.098f5042.svg";